// @ts-strict-ignore
import { getAxiosInstance } from '@/hybrid/requests/axios.utilities';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';
import { getHref } from '@/hybrid/utilities/utilities';

export function getItemForTool(item) {
  return getAxiosInstance().get(APPSERVER_API_PREFIX + getHref(item));
}
